import React, { useState, useContext, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { toggleScroll } from 'gatsby-core-theme/src/helpers/scroll';
import { NavigationContext } from 'gatsby-core-theme/src/components/organisms/navigation/navigationContext';
import NotificationItems from './notification-items';
import BellIcon from '~images/icons/bell';
import styles from './notifications.module.scss';

const Notifications = ({ section }) => {
  const { setShowSearch, setShowMenu, showMenu, showSearch } = useContext(NavigationContext);
  const notificationRef = useRef(null);
  const [newNotification, setNewNotification] = useState(true);
  const [openNotification, setOpenNotification] = useState(false);

  const { modules } = section || {};
  const getNotifications = () => modules?.find((module) => module?.name === 'spotlights') || {};

  const notificationActions = () => {
    setNewNotification(false);
    setOpenNotification(!openNotification);

    if (showSearch) {
      toggleScroll('search');
      setShowSearch(!showSearch);
    }
    if (showMenu) {
      toggleScroll('menu');
      setShowMenu(!showMenu);
    }

  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setOpenNotification(false);
      }
    }

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [notificationRef]);

  return (
    <div ref={notificationRef} className={styles?.notificationOuter || ''}>
      <div
        className={`${styles.notificationIcon || ''} ${
          newNotification ? styles.newNotification || '' : ''
        } notification-bell-gtm`}
        onKeyDown={() => notificationActions()}
        onClick={() => notificationActions()}
        role="button"
        aria-label="Notification Bell Icon"
        tabIndex={0}
      >
        <BellIcon />
      </div>
      {openNotification && (
        <NotificationItems module={getNotifications()} onClose={() => notificationActions()} />
      )}
    </div>
  );
};

Notifications.propTypes = {
  pageContext: PropTypes.shape({}),
  section: PropTypes.shape({}),
};

export default Notifications;